import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.replace.js";
import Vue from 'vue';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../src/layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';

/* Plugins */

import nuxt_plugin_sentryserver_485e2b94 from 'nuxt_plugin_sentryserver_485e2b94'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_761778ae from 'nuxt_plugin_sentryclient_761778ae'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_47423903 from 'nuxt_plugin_plugin_47423903'; // Source: ../node_modules/@pinia/nuxt/dist/runtime/plugin.vue2 (mode: 'all')
import nuxt_plugin_appplugin_2375e480 from 'nuxt_plugin_appplugin_2375e480'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_1e0439cf from 'nuxt_plugin_configplugin_1e0439cf'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_05e20bf0 from 'nuxt_plugin_nitrobridgeserver_05e20bf0'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_a8cb8ae0 from 'nuxt_plugin_nitrobridgeclient_a8cb8ae0'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_recaptcha_a6927c3e from 'nuxt_plugin_recaptcha_a6927c3e'; // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtdevicedetectplugin6c154e77_1cc4aac7 from 'nuxt_plugin_nuxtdevicedetectplugin6c154e77_1cc4aac7'; // Source: ./nuxt-device-detect.plugin.6c154e77.js (mode: 'all')
import nuxt_plugin_pluginutils_3a8ae409 from 'nuxt_plugin_pluginutils_3a8ae409'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_79629314 from 'nuxt_plugin_pluginrouting_79629314'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_29c150db from 'nuxt_plugin_pluginmain_29c150db'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_googletagmanager_4fb96a40 from 'nuxt_plugin_googletagmanager_4fb96a40'; // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_vuescrollto_771bc557 from 'nuxt_plugin_vuescrollto_771bc557'; // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_capiplugin_617750e1 from 'nuxt_plugin_capiplugin_617750e1'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_2e6fe8e8 from 'nuxt_plugin_errorpluginserver_2e6fe8e8'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_fetch_34eab5f8 from 'nuxt_plugin_fetch_34eab5f8'; // Source: ../src/plugins/fetch (mode: 'all')
import nuxt_plugin_env_5e4631b7 from 'nuxt_plugin_env_5e4631b7'; // Source: ../src/plugins/env (mode: 'all')
import nuxt_plugin_localstorage_398adf26 from 'nuxt_plugin_localstorage_398adf26'; // Source: ../src/plugins/localstorage (mode: 'client')
import nuxt_plugin_constants_56a5fa99 from 'nuxt_plugin_constants_56a5fa99'; // Source: ../src/plugins/constants (mode: 'all')
import nuxt_plugin_errorhandler_1dde38cf from 'nuxt_plugin_errorhandler_1dde38cf'; // Source: ../src/plugins/error-handler (mode: 'all')
import nuxt_plugin_util_6a876078 from 'nuxt_plugin_util_6a876078'; // Source: ../src/plugins/util (mode: 'all')
import nuxt_plugin_dayjs_35268fa2 from 'nuxt_plugin_dayjs_35268fa2'; // Source: ../src/plugins/dayjs (mode: 'all')
import nuxt_plugin_adservice_b00e7308 from 'nuxt_plugin_adservice_b00e7308'; // Source: ../src/plugins/adservice (mode: 'all')
import nuxt_plugin_referral_6ff47dda from 'nuxt_plugin_referral_6ff47dda'; // Source: ../src/plugins/referral (mode: 'all')
import nuxt_plugin_services_454c55d4 from 'nuxt_plugin_services_454c55d4'; // Source: ../src/plugins/services (mode: 'all')
import nuxt_plugin_fontawesome_b8d42804 from 'nuxt_plugin_fontawesome_b8d42804'; // Source: ../src/plugins/fontawesome (mode: 'all')
import nuxt_plugin_vueinfinitescroll_18d3fb29 from 'nuxt_plugin_vueinfinitescroll_18d3fb29'; // Source: ../src/plugins/vue-infinite-scroll (mode: 'client')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f'; // Source: ../src/plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_vuechartjs_148d29ac from 'nuxt_plugin_vuechartjs_148d29ac'; // Source: ../src/plugins/vue-chartjs (mode: 'client')
import nuxt_plugin_vuevisibilitychange_878bbee4 from 'nuxt_plugin_vuevisibilitychange_878bbee4'; // Source: ../src/plugins/vue-visibility-change (mode: 'client')
import nuxt_plugin_vuelazyload_211b2937 from 'nuxt_plugin_vuelazyload_211b2937'; // Source: ../src/plugins/vue-lazyload (mode: 'client')
import nuxt_plugin_vtooltip_74057214 from 'nuxt_plugin_vtooltip_74057214'; // Source: ../src/plugins/v-tooltip (mode: 'client')
import nuxt_plugin_focus_34e219bc from 'nuxt_plugin_focus_34e219bc'; // Source: ../src/plugins/focus (mode: 'client')
import nuxt_plugin_platform_6e622370 from 'nuxt_plugin_platform_6e622370'; // Source: ../src/plugins/platform.client (mode: 'client')
import nuxt_plugin_mchplusauth_2063fb1f from 'nuxt_plugin_mchplusauth_2063fb1f'; // Source: ../src/plugins/mchplus-auth (mode: 'all')
import nuxt_plugin_init_6a81d586 from 'nuxt_plugin_init_6a81d586'; // Source: ../src/plugins/init (mode: 'all')
import nuxt_plugin_global_6441a2ce from 'nuxt_plugin_global_6441a2ce'; // Source: ../src/plugins/global (mode: 'all')
import nuxt_plugin_masterdata_071d52ff from 'nuxt_plugin_masterdata_071d52ff'; // Source: ../src/plugins/master-data (mode: 'all')
import nuxt_plugin_toast_3357971e from 'nuxt_plugin_toast_3357971e'; // Source: ../src/plugins/toast (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = null;
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Create Root instance
          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": "BRAVE FRONTIER HEROES",
              "meta": [{
                "charset": "utf-8"
              }, {
                "http-equiv": "x-ua-compatible",
                "content": "ie=edge"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1"
              }],
              "link": [{
                "rel": "icon",
                "type": "image/png",
                "href": "/favicon.png"
              }, {
                "rel": "stylesheet",
                "href": "https://fonts.googleapis.com/css?family=Noto+Sans+JP|Vollkorn+SC|Cardo&display=swap"
              }],
              "script": [{
                "src": "https://js.stripe.com/v3/"
              }, {
                "src": "//www.googletagmanager.com/gtm.js?id=GTM-N82M345&l=dataLayer",
                "async": true
              }],
              "style": [],
              "noscript": [{
                "hid": "gtm-noscript",
                "innerHTML": "<iframe src=\"//www.googletagmanager.com/ns.html?id=GTM-N82M345&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>",
                "pbody": true
              }],
              "__dangerouslyDisableSanitizersByTagID": {
                "gtm-noscript": ["innerHTML"]
              }
            },
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App);
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 11;
          return setContext(app, {
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 11:
          // Inject runtime config as $config
          inject('config', config);

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(process.server && typeof nuxt_plugin_sentryserver_485e2b94 === 'function')) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return nuxt_plugin_sentryserver_485e2b94(app.context, inject);
        case 16:
          if (!(process.client && typeof nuxt_plugin_sentryclient_761778ae === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_sentryclient_761778ae(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_plugin_47423903 === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_plugin_47423903(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_appplugin_2375e480 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_appplugin_2375e480(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_configplugin_1e0439cf === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_configplugin_1e0439cf(app.context, inject);
        case 28:
          if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_05e20bf0 === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_nitrobridgeserver_05e20bf0(app.context, inject);
        case 31:
          if (!(process.client && typeof nuxt_plugin_nitrobridgeclient_a8cb8ae0 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_nitrobridgeclient_a8cb8ae0(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_recaptcha_a6927c3e === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_recaptcha_a6927c3e(app.context, inject);
        case 37:
          if (!(typeof nuxt_plugin_nuxtdevicedetectplugin6c154e77_1cc4aac7 === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_nuxtdevicedetectplugin6c154e77_1cc4aac7(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_pluginutils_3a8ae409 === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_pluginutils_3a8ae409(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_pluginrouting_79629314 === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_pluginrouting_79629314(app.context, inject);
        case 46:
          if (!(typeof nuxt_plugin_pluginmain_29c150db === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_pluginmain_29c150db(app.context, inject);
        case 49:
          if (!(process.client && typeof nuxt_plugin_googletagmanager_4fb96a40 === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_googletagmanager_4fb96a40(app.context, inject);
        case 52:
          if (!(process.client && typeof nuxt_plugin_vuescrollto_771bc557 === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_vuescrollto_771bc557(app.context, inject);
        case 55:
          if (!(typeof nuxt_plugin_capiplugin_617750e1 === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_capiplugin_617750e1(app.context, inject);
        case 58:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_2e6fe8e8 === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_errorpluginserver_2e6fe8e8(app.context, inject);
        case 61:
          if (!(typeof nuxt_plugin_fetch_34eab5f8 === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_fetch_34eab5f8(app.context, inject);
        case 64:
          if (!(typeof nuxt_plugin_env_5e4631b7 === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_env_5e4631b7(app.context, inject);
        case 67:
          if (!(process.client && typeof nuxt_plugin_localstorage_398adf26 === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_localstorage_398adf26(app.context, inject);
        case 70:
          if (!(typeof nuxt_plugin_constants_56a5fa99 === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_constants_56a5fa99(app.context, inject);
        case 73:
          if (!(typeof nuxt_plugin_errorhandler_1dde38cf === 'function')) {
            _context2.next = 76;
            break;
          }
          _context2.next = 76;
          return nuxt_plugin_errorhandler_1dde38cf(app.context, inject);
        case 76:
          if (!(typeof nuxt_plugin_util_6a876078 === 'function')) {
            _context2.next = 79;
            break;
          }
          _context2.next = 79;
          return nuxt_plugin_util_6a876078(app.context, inject);
        case 79:
          if (!(typeof nuxt_plugin_dayjs_35268fa2 === 'function')) {
            _context2.next = 82;
            break;
          }
          _context2.next = 82;
          return nuxt_plugin_dayjs_35268fa2(app.context, inject);
        case 82:
          if (!(typeof nuxt_plugin_adservice_b00e7308 === 'function')) {
            _context2.next = 85;
            break;
          }
          _context2.next = 85;
          return nuxt_plugin_adservice_b00e7308(app.context, inject);
        case 85:
          if (!(typeof nuxt_plugin_referral_6ff47dda === 'function')) {
            _context2.next = 88;
            break;
          }
          _context2.next = 88;
          return nuxt_plugin_referral_6ff47dda(app.context, inject);
        case 88:
          if (!(typeof nuxt_plugin_services_454c55d4 === 'function')) {
            _context2.next = 91;
            break;
          }
          _context2.next = 91;
          return nuxt_plugin_services_454c55d4(app.context, inject);
        case 91:
          if (!(typeof nuxt_plugin_fontawesome_b8d42804 === 'function')) {
            _context2.next = 94;
            break;
          }
          _context2.next = 94;
          return nuxt_plugin_fontawesome_b8d42804(app.context, inject);
        case 94:
          if (!(process.client && typeof nuxt_plugin_vueinfinitescroll_18d3fb29 === 'function')) {
            _context2.next = 97;
            break;
          }
          _context2.next = 97;
          return nuxt_plugin_vueinfinitescroll_18d3fb29(app.context, inject);
        case 97:
          if (!(process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function')) {
            _context2.next = 100;
            break;
          }
          _context2.next = 100;
          return nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject);
        case 100:
          if (!(process.client && typeof nuxt_plugin_vuechartjs_148d29ac === 'function')) {
            _context2.next = 103;
            break;
          }
          _context2.next = 103;
          return nuxt_plugin_vuechartjs_148d29ac(app.context, inject);
        case 103:
          if (!(process.client && typeof nuxt_plugin_vuevisibilitychange_878bbee4 === 'function')) {
            _context2.next = 106;
            break;
          }
          _context2.next = 106;
          return nuxt_plugin_vuevisibilitychange_878bbee4(app.context, inject);
        case 106:
          if (!(process.client && typeof nuxt_plugin_vuelazyload_211b2937 === 'function')) {
            _context2.next = 109;
            break;
          }
          _context2.next = 109;
          return nuxt_plugin_vuelazyload_211b2937(app.context, inject);
        case 109:
          if (!(process.client && typeof nuxt_plugin_vtooltip_74057214 === 'function')) {
            _context2.next = 112;
            break;
          }
          _context2.next = 112;
          return nuxt_plugin_vtooltip_74057214(app.context, inject);
        case 112:
          if (!(process.client && typeof nuxt_plugin_focus_34e219bc === 'function')) {
            _context2.next = 115;
            break;
          }
          _context2.next = 115;
          return nuxt_plugin_focus_34e219bc(app.context, inject);
        case 115:
          if (!(process.client && typeof nuxt_plugin_platform_6e622370 === 'function')) {
            _context2.next = 118;
            break;
          }
          _context2.next = 118;
          return nuxt_plugin_platform_6e622370(app.context, inject);
        case 118:
          if (!(typeof nuxt_plugin_mchplusauth_2063fb1f === 'function')) {
            _context2.next = 121;
            break;
          }
          _context2.next = 121;
          return nuxt_plugin_mchplusauth_2063fb1f(app.context, inject);
        case 121:
          if (!(typeof nuxt_plugin_init_6a81d586 === 'function')) {
            _context2.next = 124;
            break;
          }
          _context2.next = 124;
          return nuxt_plugin_init_6a81d586(app.context, inject);
        case 124:
          if (!(typeof nuxt_plugin_global_6441a2ce === 'function')) {
            _context2.next = 127;
            break;
          }
          _context2.next = 127;
          return nuxt_plugin_global_6441a2ce(app.context, inject);
        case 127:
          if (!(typeof nuxt_plugin_masterdata_071d52ff === 'function')) {
            _context2.next = 130;
            break;
          }
          _context2.next = 130;
          return nuxt_plugin_masterdata_071d52ff(app.context, inject);
        case 130:
          if (!(typeof nuxt_plugin_toast_3357971e === 'function')) {
            _context2.next = 133;
            break;
          }
          _context2.next = 133;
          return nuxt_plugin_toast_3357971e(app.context, inject);
        case 133:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 136;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 136:
          return _context2.abrupt("return", {
            app: app,
            router: router
          });
        case 137:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };